import { getFidelities, getFidelitiesFromSales, getUserPayments } from "../shared/requests-api";
import {
	FIDELITY_PLANS_FROM_USER_SALES_RECEIVED,
	FIDELITY_PLANS_FROM_USER_SALES_EMPTY,
	FIDELITY_PLANS_RECEIVED,
	USER_PAYMENTS_HAS_ERROR,
	USER_PAYMENTS_RECEIVED,
	USER_PAYMENTS_WAS_REQUESTED,
	UTIL_DATA_WAS_REQUESTED
} from "../shared/constants";

// Busca os planos de fidelidade
export const getAllFidelityPlans = () => {
	return function(dispatch) {
		dispatch({
			type: UTIL_DATA_WAS_REQUESTED
		});
		getFidelities(undefined, 1).then(success => {
			let plans = success.data
				.map(company => company.fidelities)
				.reduce((companyPlans, current) => {
					return companyPlans.concat(current);
				}, []);

			dispatch({
				type: FIDELITY_PLANS_RECEIVED,
				payload: plans
			});
		});
	};
};

// Busca os planos de fidelidade baseado nas vendas do usuário
export const getFidelityPlansFromUserSales = () => {
	return function(dispatch) {
		dispatch({
			type: UTIL_DATA_WAS_REQUESTED
		});
		getFidelitiesFromSales().then(success => {
			dispatch({
				type: FIDELITY_PLANS_FROM_USER_SALES_RECEIVED,
				payload: success
			});
		})
		.catch(error => {
			if(error.response.status === 404){
				dispatch({
					type: FIDELITY_PLANS_FROM_USER_SALES_EMPTY,
				});
			}
		});
	};
};

// Busca o relatorio de pagamentos do usuario
export const findUserPayments = () => {
	return function(dispatch) {
		dispatch({
			type: USER_PAYMENTS_WAS_REQUESTED
		});

		getUserPayments()
			.then(success => {
				dispatch({
					type: USER_PAYMENTS_RECEIVED,
					payload: success.data
				});
			})
			.catch(error => {
				dispatch({
					type: USER_PAYMENTS_HAS_ERROR
				});
			});
	};
};
